import { render, staticRenderFns } from "./DayForm.vue?vue&type=template&id=20974cda&scoped=true&"
import script from "./DayForm.vue?vue&type=script&lang=js&"
export * from "./DayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20974cda",
  null
  
)

export default component.exports